export const ContactSalesPagePTBRTranslations = {
  contactSalesPageHeadTitle: 'Falar com vendas | 4intellingence',
  contactSalesPageHeadDescription:
    'Tire suas dúvidas conosco. Fale com nossos especialistas',
  contactSalesPageTitle:
    'Contate nosso time de vendas e saiba mais sobre como podemos ajudar seu negócio!',
  contactSalesPageDescription:
    'Preencha o formulário ou use o botão abaixo para nos contatar pelo Whatsapp!',
  contactSalesPageWhatsappButton: 'Falar pelo Whatsapp',
};
